import React from 'react'
import { colors } from 'src/assets/colors'
import { AbstractButton, IButtonProps } from './AbstractButton'

export const PrimaryDanger = (props: IButtonProps) => (
  <AbstractButton
    loading={props.loading}
    disabled={props.disabled}
    onPress={props.onPress}
    title={props.title}
    subtitle={props.subtitle}
    testID={props.testID}
    textColor={colors.textLight}
    backgroundColor={props.disabled ? colors.red30 : colors.red50}
  />
)
